<template>
  <el-dialog
    title="批量上传"
    :visible="visible"
    width="850px"
    center
    custom-class="batch-upload-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <el-timeline>
      <el-timeline-item type="primary" hide-timestamp style="padding-bottom:25px">
        <span>步骤一</span>
        <el-button type="primary" size="small" style="margin-left: 30px" @click="genTemplate">下载模板</el-button>
      </el-timeline-item>
      <el-timeline-item v-if="showRightFileUpload" type="primary" hide-timestamp style="padding-bottom:40px">
        <span>步骤二</span>
        <p class="step-two-content">
          注意！清单中的权利文件一列，用于填写被侵权歌曲对应的权利文件的文件名
          填写的文件名需要与上传的文件的文件名完全一致，包含带后缀名({{ rightFileExtType.join(',') }})
        </p>
      </el-timeline-item>
      <el-timeline-item type="primary" hide-timestamp>
        <span>步骤{{ showRightFileUpload ? '三' : '二' }}</span>
        <div class="step-three-content">
          <section>
            <verify-uploader
              action="/action/upload?type=excel"
              drag
              :on-preview="handlePreview"
              :on-remove="handleFileRemove"
              :on-error="handleFileError"
              :on-success="handleFileSuccess"
              :before-upload="handleFileBeforeUpload"
              :file-list="fileList"
              :accept="'.' + fileExtType.join(',.')"
            >
              <div slot="trigger" class="upload-trigger">
                <svg-icon icon-class="upload" class="upload-icon"></svg-icon>
                <p>点击或将文件拖拽上传表格</p>
                <span>支持格式：{{ fileExtType.join(',') }}</span>
              </div>
            </verify-uploader>
          </section>
          <section v-if="showRightFileUpload">
            <verify-uploader
              action="/action/upload?type=license"
              drag
              multiple
              :on-preview="handlePreview"
              :on-remove="handleRightFileRemove"
              :on-error="handleRightFileError"
              :on-success="handleRightFileSuccess"
              :before-upload="handleRightFileBeforeUpload"
              :file-list="rightFileList"
              :accept="'.' + rightFileExtType.join(',.')"
            >
              <div slot="trigger" class="upload-trigger">
                <svg-icon icon-class="upload" class="upload-icon"></svg-icon>
                <p>点击或将文件拖拽上传权利文件</p>
                <span>支持格式：{{ rightFileExtType.join(',') }}</span>
              </div>
            </verify-uploader>
          </section>
        </div>
      </el-timeline-item>
    </el-timeline>
    <div slot="footer" style="margin-top:30px">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确认提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { cloneDeep } from 'lodash-es'
import { VerifyUploader } from '@/components'
import batchUpload from './mixin/batchUpload'

export default {
  name: 'BatchUploadDialog',
  components: {
    VerifyUploader
  },
  mixins: [batchUpload],
  props: {
    needRight: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    handleClose() {
      this.fileList = []
      this.rightFileList = []
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    handleRightFileSuccess(resp, file, fileList) {
      this.handleSuccess(resp, file)
      this.rightFileList = fileList
    },
    handleSubmit() {
      if (!this.fileList.length) {
        return this.$message.warning('请上传文件！')
      }
      if (this.showRightFileUpload && this.needRight && !this.rightFileList.length) {
        return this.$message.warning('请上传权利文件！')
      }

      this.$emit('submit', cloneDeep(this.fileList), cloneDeep(this.rightFileList))
      this.handleClose()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .batch-upload-dialog {

  .el-dialog__header {
    border-bottom: 0;
  }

  .el-dialog__footer {
    border-top: 0;
  }

  .el-timeline-item__tail {
    border-left-color: #4071ff;
  }

  .el-upload-list {
    text-align: left;
  }

  .el-upload.el-upload--text {
    width: 100%;
    background: #FAFBFB;
    border: 1px dashed #4071FF;
    border-radius: 4px;
    padding: 10px;
  }

  .el-upload-dragger {
    background-color: unset;
    border: none;
    width: 100%;
    min-height: 180px;
    height: 100%;
  }

  .upload-icon {
    width: 42px;
    height: 50px;
  }
}

.step-two-content {
  width: 500px;
  margin-top: 10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: rgba(0, 36, 68, 0.8);
}

.step-three-content {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  margin-top: 36px;

  section {
    width: 380px;
    border: 1px solid #D9DEE1;
    border-radius: 4px;
    padding: 10px;
    text-align: center;

    p {
      font-size: 16px;
      color: #002432;
    }

    span {
      display: inline-block;
      margin-top: 8px;
      color: #8C9CA3;
    }
  }
}
</style>
